import { Dispatch } from "@reduxjs/toolkit";
import { setCurrency } from "./reducer";
import { CurrencyState } from "../../utils/interfaces/currency";

export const currencyActionDispatch = (dispatch: Dispatch) => ({
  setCurrency: (currency: CurrencyState) => dispatch(setCurrency(currency)),
});
